import type { Country } from '@/types'

const countries: Record<Country['code'], Omit<Country, 'code'>> = {
  ae: {
    name: 'United Arab Emirates',
    locales: ['en']
  },
  at: {
    name: 'Austria',
    locales: ['de', 'en']
  },
  be: {
    name: 'Belgium',
    locales: ['en', 'fr']
  },
  cz: {
    name: 'Czech Republic',
    locales: ['en']
  },
  de: {
    name: 'Germany',
    locales: ['de', 'en']
  },
  dk: {
    name: 'Denmark',
    locales: ['en']
  },
  es: {
    name: 'Spain',
    locales: ['es', 'en']
  },
  fi: {
    name: 'Finland',
    locales: ['en']
  },
  fr: {
    name: 'France',
    locales: ['fr', 'en']
  },
  gb: {
    name: 'United Kingdom',
    locales: ['en']
  },
  gr: {
    name: 'Greece',
    locales: ['en']
  },
  hu: {
    name: 'Hungary',
    locales: ['en']
  },
  ie: {
    name: 'Ireland',
    locales: ['en']
  },
  it: {
    name: 'Italy',
    locales: ['it', 'en']
  },
  lu: {
    name: 'Luxembourg',
    locales: ['fr', 'en', 'de']
  },
  nl: {
    name: 'Netherlands',
    locales: ['en']
  },
  pl: {
    name: 'Poland',
    locales: ['en']
  },
  pt: {
    name: 'Portugal',
    locales: ['en']
  },
  ro: {
    name: 'Romania',
    locales: ['en']
  },
  se: {
    name: 'Sweden',
    locales: ['en']
  },
  si: {
    name: 'Slovenia',
    locales: ['en']
  },
  default: {
    name: 'Other',
    locales: ['en']
  }
}

export default countries
